import React, { useState } from 'react';
import { X } from 'lucide-react';
import Select from 'react-select'; // Added import for Select component
import '../../styles/EditStudentPopup.css'

const EditStudentPopup = ({ student, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    enrollment_status: student.enrollment_status || 'Select Enrollment Status',
    follow_up: student.follow_up || '',
    admin_feedback: student.admin_feedback || '',
    source: student.source || '' // Added source to formData
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const enrollmentStatusOptions = [
    'Select Enrollment Status',
    'Hot',
    'Warm',
    'Postive',
    'Cold',
    'Ringing',
    'Joined',
    'Scrab',
    'Not interested',
    'Un touched',
    'Switch off',
    'Will update',
    'Call rejected',
    'Not reachable'
  ];

  // Added sourceOptions array
  const sourceOptions = [
    { value: 'Meta', label: 'Meta' },
    { value: 'Website Call', label: 'Website Call' },
    { value: 'Web Form', label: 'Web Form' },
    { value: 'Student Reference', label: 'Student Reference' },
    { value: 'Direct WalkIn', label: 'Direct WalkIn' },
    { value: 'Direct Call', label: 'Direct Call' },
    { value: 'Sulekha', label: 'Sulekha' },
    { value: 'Website Msg', label: 'Website Msg' },
    { value: 'Instagram', label: 'Instagram' },
    { value: 'Youtube', label: 'Youtube' },
    { value: 'LinkedIn', label: 'LinkedIn' },
    { value: 'Google WhatsAPP', label: 'Google WhatsAPP' },
    { value: 'Google AD', label: 'Google AD' },
    { value: 'APNA', label: 'APNA' },
    { value: 'Naukri', label: 'Naukri' },
    { value: 'INDEED', label: 'INDEED' },
    { value: 'HR Job Portal', label: 'HR Job Portal' },
    { value: 'IndiaMART', label: 'IndiaMART' },
    { value: 'Just Dial', label: 'Just Dial' },
    { value: 'MD Reference', label: 'MD Reference' },
    { value: 'Other Reference', label: 'Other Reference' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('token');
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/students/${student.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
  
      if (!response.ok) {
        throw new Error('Failed to update student information');
      }
  
      const updatedStudent = await response.json();
      
      // ✅ Only pass the student object, not the whole response
      onSave(updatedStudent.data);
      onClose();
    } catch (err) {
      console.error("Error updating student:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-header">
          <h2>Edit Student: {student.name}</h2>
          <button className="close-button" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="popup-form">
          <div className="form-group">
            <label htmlFor="enrollment_status">Enrollment Status:</label>
            <select
              id="enrollment_status"
              name="enrollment_status"
              value={formData.enrollment_status}
              onChange={handleChange}
              required
            >
              {enrollmentStatusOptions.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>
          
          {/* Added Source field */}
          <div className="form-group">
            <label>Source:</label>
            <Select
              name="source"
              options={sourceOptions}
              value={sourceOptions.find(option => option.value === formData.source)}
              onChange={selectedOption =>
                handleChange({ target: { name: 'source', value: selectedOption?.value } })
              }
              placeholder="Choose Your Source"
              isSearchable
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="follow_up">Follow-up Date:</label>
            <input
              type="date"
              id="follow_up"
              name="follow_up"
              value={formData.follow_up}
              onChange={handleChange}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="admin_feedback">Admin Feedback:</label>
            <textarea
              id="admin_feedback"
              name="admin_feedback"
              value={formData.admin_feedback}
              onChange={handleChange}
              rows="4"
            ></textarea>
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <div className="popup-actions">
            <button type="button" className="cancel-button" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="save-button" disabled={loading}>
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditStudentPopup;